import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import App from 'App';
import { BASE_PATH } from 'config';
import { store, persister } from 'store';
import { LicenseInfo } from '@mui/x-license-pro';
import 'assets/scss/style.scss';
import { IS_REMOTE, SENTRY_ENV } from 'constants/envConstants';

LicenseInfo.setLicenseKey(process.env.MUI_LICENSE_KEY || '');

if (IS_REMOTE) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.GIT_RELEASE_SHA || 'unknown',
    environment: SENTRY_ENV,
    debug: SENTRY_ENV === 'qa',
    // Replay integration is added conditionally within AuthGuard
    // These rates are required for replay to work when integration is added
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,
    // @ts-ignore profileSessionSampleRate exists in Sentry 10 BrowserClientProfilingOptions; TS resolution quirk
    profileSessionSampleRate: SENTRY_ENV === 'prod' ? 0.1 : 1,
    profileLifecycle: 'trace',
    normalizeDepth: 5,
    tracePropagationTargets: [
      'https://platform.cofactr.com',
      'https://flagship-api.cofactr.com',
      'https://qa-flagship-api.cofactr.com',
      'https://qa-platform.cofactr.com',
    ],
  });
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
